export enum CommonParams {
  TAB = 'tab',
}
